/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:55 PM
 *
 */

import ProfileTestPrint from 'features/members/components/others/ProfileTestPrint/ProfileTestPrint';

export default ProfileTestPrint;
